module.exports = require('./helpers/bundle-url').getBundleURL('kmvYf') + "kamal-raddaoui.37aa0af9.jpg" + "?" + Date.now();